import React, { useState } from 'react'
import { Button, Grid, TextField, InputAdornment } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Field } from 'formik';
import DatePicker from '../DatePicker';
import { useStore } from '../../Store'
import { getErrorProps, getOptions, plotItems } from '../../utils'
import Photos from '../Photos';
import LogboekGegevens from './LogboekGegevens'
import CustomData from './CustomData';
import Buddies from '../Buddies';

const VisitDetails = ({ readonly, formik }) => {

    const { plots, settings } = useStore()
    const [openObjectInfo, setOpenObjectInfo] = useState(false)
    const moo = plots.find(p => p.id === formik.values.plot).folderTypeId === 6104

    const updateDescription = (value) => {
        const description = (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
        formik.setFieldValue('description', description)
    }



    return (
        <Grid container>
            <Grid item xs={12} >
                <Alert severity="info">{moo ? 'MOO' : 'LIMP'}</Alert>
            </Grid>
            <Grid item xs={12}>
                <TextField select disabled={true} label="telgebied" variant="standard" name="plot" fullWidth {...getErrorProps(formik, "plot")} {...formik.getFieldProps('plot')} >
                    {plotItems(plots)}
                </TextField>
            </Grid>

            <Grid item xs={12} >
                <Field disabled={readonly} label="bezoekdatum" variant="standard" name="dateStart" fullWidth {...getErrorProps(formik, "dateStart")} component={DatePicker}
                    onChange={updateDescription} />
            </Grid>

            <Grid item xs={12} >
                <TextField disabled={readonly} label="starttijd" variant="standard" name="timeStart" type="time" placeholder="hh:mm" fullWidth {...getErrorProps(formik, "timeStart")} {...formik.getFieldProps('timeStart')} />
            </Grid>

            <Grid item xs={12} >
                <TextField disabled={readonly} label="eindtijd" autoComplete="off" variant="standard" name="timeStop" type="time" placeholder="hh:mm" fullWidth {...getErrorProps(formik, "timeStop")} {...formik.getFieldProps('timeStop')} />
            </Grid>

            <Grid item xs={12} >
                <TextField disabled={readonly} label="opmerkingen" multiline variant="standard" name="extraInfo.opmerking_bezoek" fullWidth  {...getErrorProps(formik, "extraInfo.opmerking_bezoek")} {...formik.getFieldProps('extraInfo.opmerking_bezoek')} />
            </Grid>

            {moo ?
                <>
                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="getij" variant="standard" name="extraInfo.getij" fullWidth  {...getErrorProps(formik, "extraInfo.getij")} {...formik.getFieldProps('extraInfo.getij')} >
                            {getOptions(settings.lists["getij"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} >
                        <Alert severity="info">Waarnemingsduur per diepte</Alert>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomData disabled={readonly} value={formik.values.extraInfo.onderzoeksduur} name="extraInfo.onderzoeksduur" formik={formik} />
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="maximale diepte" variant="standard" name="extraInfo.max_diepte" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.max_diepte")} {...formik.getFieldProps('extraInfo.max_diepte')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">m.</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="zicht in meters" variant="standard" name="extraInfo.zicht" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.zicht")} {...formik.getFieldProps('extraInfo.zicht')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">m.</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="gegevens buddy" variant="standard" name="extraInfo.gegevens_buddy" fullWidth  {...getErrorProps(formik, "extraInfo.gegevens_buddy")} {...formik.getFieldProps('extraInfo.gegevens_buddy')} >
                            {getOptions(settings.lists["gegevens_buddy"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} >
                        <Field disabled={readonly} label="buddies" variant="standard" name="buddies" fullWidth {...getErrorProps(formik, "buddies")} component={Buddies} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="volgens MOO methodiek" variant="standard" name="extraInfo.methodiek" fullWidth  {...getErrorProps(formik, "extraInfo.methodiek")} {...formik.getFieldProps('extraInfo.methodiek')} >
                            {getOptions(settings.lists["methodiek"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="alleen gesnorkeld" variant="standard" name="extraInfo.gesnorkeld" fullWidth  {...getErrorProps(formik, "extraInfo.gesnorkeld")} {...formik.getFieldProps('extraInfo.gesnorkeld')} >
                            {getOptions(settings.lists["gesnorkeld"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} >
                        <Alert severity="info">
                            Aanvullende bezoekgegevens (gewenst maar niet verplicht):
                        </Alert>
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="geschat aantal duikers" variant="standard" name="extraInfo.aantal_duikers" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.aantal_duikers")} {...formik.getFieldProps('extraInfo.aantal_duikers')} />
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="aantal Europese zeekreeften" variant="standard" name="extraInfo.aantal_zeekreeften" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.aantal_zeekreeften")} {...formik.getFieldProps('extraInfo.aantal_zeekreeften')} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="spronglaag (Thermocline)" variant="standard" name="extraInfo.spronglaag" fullWidth  {...getErrorProps(formik, "extraInfo.spronglaag")} {...formik.getFieldProps('extraInfo.spronglaag')} >
                            {getOptions(settings.lists["spronglaag"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="diepte spronglaag" variant="standard" name="extraInfo.diepte_spronglaag" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.diepte_spronglaag")} {...formik.getFieldProps('extraInfo.diepte_spronglaag')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">m.</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="gemiddelde watertemperatuur" variant="standard" name="extraInfo.watertemperatuur" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.watertemperatuur")} {...formik.getFieldProps('extraInfo.watertemperatuur')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">&#8451;</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12} >
                        <TextField disabled={readonly} label="max diepte vegetatie/wieren" variant="standard" name="extraInfo.max_diepte_vegetatie" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.max_diepte_vegetatie")} {...formik.getFieldProps('extraInfo.max_diepte_vegetatie')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">m.</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="bacterie/schimmels bodem" variant="standard" name="extraInfo.bacterie_bodem" fullWidth  {...getErrorProps(formik, "extraInfo.bacterie_bodem")} {...formik.getFieldProps('extraInfo.bacterie_bodem')} >
                            {getOptions(settings.lists["bacterie_bodem"])}
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="outlined" onClick={() => setOpenObjectInfo(true)}>Logboek gegevens</Button>
                    </Grid>
                </> : null}

            {!moo ?
                <>
                    <Grid item xs={12} >
                        <Field disabled={readonly} label="buddies" variant="standard" name="buddies" fullWidth {...getErrorProps(formik, "buddies")} component={Buddies} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="extra laagwater" variant="standard" name="extraInfo.extra_laagwater" fullWidth  {...getErrorProps(formik, "extraInfo.extra_laagwater")} {...formik.getFieldProps('extraInfo.extra_laagwater')} >
                            {getOptions(settings.lists["extra_laagwater"])}
                        </TextField>
                    </Grid>
                </>
                : null}

            <Grid item xs={12}>
                <Photos
                    uploads={formik.values.uploads || []}
                    setUploads={(uploads) => formik.setFieldValue('uploads', uploads)}
                    readonly={readonly}
                    formik={formik}
                />
            </Grid>

            <LogboekGegevens formik={formik} readonly={readonly} onClose={() => setOpenObjectInfo(false)} open={openObjectInfo} />


        </Grid>
    )
}


export default VisitDetails